import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import PeopleIcon from "@mui/icons-material/People";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ExploreIcon from "@mui/icons-material/Explore";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DescriptionIcon from "@mui/icons-material/Description";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ScheduleIcon from "@mui/icons-material/Schedule";
import ChatIcon from "@mui/icons-material/Chat";
import {
  Dashboard as DashboardIcon,
  Assignment as RequirementIcon,
  Settings,
} from "@mui/icons-material";
import BarChartIcon from "@mui/icons-material/BarChart";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import AssessmentIcon from "@mui/icons-material/Assessment";
import HistoryIcon from "@mui/icons-material/History";
import GetAppIcon from "@mui/icons-material/GetApp";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import StorefrontIcon from "@mui/icons-material/Storefront";

const sidebar = {
  "seller-farmer": [
    {
      name: "Dashboard",
      icon: <DashboardIcon />,
      link: "/seller-farmer/dashboard",
    },
    {
      name: "Trade Marketplace",
      icon: <FileCopyIcon />,
      submenu: [
        {
          name: "Produce",
          icon: <StorefrontIcon />,
          link: "/seller-farmer/produce",
        },
        {
          name: "Requirements",
          label: "Requirement",
          path: "/seller-farmer/requirement",
          icon: <RequirementIcon />,
        },
        {
          name: "RFQs",
          label: "RFQs",
          path: "/seller-farmer/rfqoffers",
          icon: <RequestQuoteIcon />,
        },
      ],
    },
    {
      name: "Finance Marketplace",
      icon: <EventAvailableIcon />,
      submenu: [
        {
          name: "My Finance Dashboard",
          label: "My Finance Dashboard",
          path: "/seller-farmer/finance/h",
          icon: <RequirementIcon />,
        },
        {
          name: "Discover & Evaluate",
          label: "Discover & Evaluate",
          path: "/seller-farmer/dis",
          icon: <ExploreIcon />,
        },
        {
          name: "RFQs & Offers",
          label: "RFQs & Offers",
          path: "/seller-farmer/finance/rfqoffers",
          icon: <RequestQuoteIcon />,
          submenu: [
            {
              name: "Payment & Financing Instruments",
              path: "/seller-farmer/finance/rfqoffers",
              icon: <ExploreIcon />,
            },
            {
              name: "Working Capital & Liquidity",
              path: "/seller-farmer/offers/working-capital",
              icon: <ExploreIcon />,
            },
            {
              name: "Risk Mitigation Tools",
              path: "/seller-farmer/offers/risk-mitigation",
              icon: <ExploreIcon />,
            },
            {
              name: "FX & Hedging Solutions",
              path: "/seller-farmer/offers/fx-hedging",
              icon: <ExploreIcon />,
            },
          ],
        },
        {
          name: "Apply for Finance",
          label: "My Offers",
          path: "/seller-farmer/ordersn",
          icon: <LocalShippingIcon />,
        },
        {
          name: "Application Tracker",
          label: "My Offers",
          path: "/seller-farmer/ordersns",
          icon: <LocalShippingIcon />,
        },
      ],
    },
    {
      name: "Documents Vault",
      icon: <FolderOpenIcon />, // Using FolderOpenIcon as a substitute
      submenu: [
        {
          name: "All Documents",
          path: "/seller-farmer/documentvault",
          icon: <DescriptionIcon />,
        },
      ],
    },

    {
      name: "Profile",
      icon: <PeopleIcon />,
      link: "/seller-farmer/profile",
    },
    {
      name: "Settings",
      icon: <Settings />,
      link: "/seller-farmer/setting",
    },
    {
      name: "Support",
      icon: <SupportAgentIcon />,
      link: "/seller-farmer/support",
    },
    {
      name: "Messaging",
      icon: <ChatIcon />,
      link: "/seller-farmer/messaging",
    },
    {
      name: "User & Roles",
      icon: <PeopleIcon />,
      link: "/seller-farmer/user-role",
    },
  ],
};

export default sidebar;
